module.exports = __webpack_public_path__ + "img/fg3.93da9058.jpg";